import React from "react";
import PropTypes from "prop-types";
import { AccordionSection } from "./AccordionSection";
import { SectionErrors } from "./SectionErrors";

export function ProductSerialsSection({ jobToComplete, productSerialsHandler, errorMessage }) {
  const isComplete = jobToComplete.completionDetail.productSerialsComplete;

  return (
    <AccordionSection
      id="productSerials"
      headerId="headerProductSerials"
      collapseId="collapseProductSerials"
      number={2}
      title="Product Serial Numbers"
      isComplete={isComplete}
    >
      <p className="text-muted mb-1">Enter details of product serial numbers</p>
      <form onSubmit={productSerialsHandler}>
        <div className="form-group mb-3">
          <label htmlFor="boilerSerial">Boiler Serial Number</label>
          <input
            className="form-control"
            type="text"
            id="boilerSerial"
            name="boilerSerial"
            disabled={isComplete}
            defaultValue={isComplete ? jobToComplete.completionDetail.boilerSerialNumber : ""}
          />
        </div>
        <div className="form-group mb-3">
          <label htmlFor="filterSerial">Filter Serial Number</label>
          <input
            className="form-control"
            type="text"
            id="filterSerial"
            name="filterSerial"
            disabled={isComplete}
            defaultValue={isComplete ? jobToComplete.completionDetail.filterSerialNumber : ""}
          />
        </div>
        <div className="d-flex flex-column flex-md-row justify-content-md-end gap-2 mt-2">
          <button
            type="submit"
            onClick={productSerialsHandler}
            className="btn btn-primary"
            disabled={isComplete}
          >
            Submit Serial Numbers
          </button>
        </div>
        <SectionErrors errorMessage={errorMessage} section="productSerials" />
      </form>
    </AccordionSection>
  );
}

ProductSerialsSection.propTypes = {
  jobToComplete: PropTypes.object.isRequired,
  productSerialsHandler: PropTypes.func.isRequired,
  errorMessage: PropTypes.array.isRequired,
};
